import {PLATFORM_TOOLS} from './platformTools.js'
export const PERSON_CC_TOOLS=Object.freeze(Object.entries({queue:'Work queue',stages:'Pursuit Stages',worklist:'Worklist · Now/Soon/Later',board:'Pursuit Board',gaps:'Gaps',assignments:'Assignments',readiness:'Readiness',hunted:'Hunted',calendar:'Calendar',justwon:'Just Won',manager:'Manager',map:'Map',artworkcreated:'Artwork Created'}).map(([key,label])=>Object.freeze({id:`cc.${key}`,label})))
export const PERSON_ARTWORK_TOOLS=Object.freeze([{id:'artwork',label:'Artwork operations'}])
export const PERSON_TOOL_GROUPS=Object.freeze([{label:'23 platform tools',tools:PLATFORM_TOOLS},{label:'13 Command Center tools',tools:PERSON_CC_TOOLS},{label:'Artwork operations',tools:PERSON_ARTWORK_TOOLS}])
export const PERSON_TOOLS=Object.freeze([...PLATFORM_TOOLS,...PERSON_CC_TOOLS,...PERSON_ARTWORK_TOOLS])
export function personRuleAllows(rule,userId){
  if(rule?.mode==='off')return false
  if(rule?.mode==='team'&&Array.isArray(rule.users)&&(!rule.excludedUsers||Array.isArray(rule.excludedUsers)))return !(rule.excludedUsers||[]).includes(userId)
  if(rule?.mode==='selected'&&Array.isArray(rule.users))return rule.users.includes(userId)
  return null
}
export function personToolSnapshot(data,userId){
  if(!data?.canManage||!Number.isSafeInteger(data.version)||typeof data.fingerprint!=='string'||!data.fingerprint)return null
  const member=data.members?.find(item=>item.id===userId&&item.active===true)
  if(!member)return null
  const values={}
  for(const tool of PERSON_TOOLS){
    if(!data.tools?.some(item=>item.id===tool.id))return null
    const allowed=personRuleAllows(data.rules?.[tool.id],userId)
    if(allowed===null)return null
    values[tool.id]=allowed
  }
  return {userId,member,version:data.version,fingerprint:data.fingerprint,values}
}
export function personToolChanges(snapshot,values){
  if(!snapshot)return []
  return PERSON_TOOLS.filter(tool=>typeof values?.[tool.id]==='boolean'&&values[tool.id]!==snapshot.values[tool.id]).map(tool=>({tool:tool.id,enabled:values[tool.id]}))
}
export function personToolStale(snapshot,data){return !snapshot||snapshot.version!==data?.version||snapshot.fingerprint!==data?.fingerprint}
export function personToolRequest(snapshot,values,reason){
  const changes=personToolChanges(snapshot,values)
  if(!snapshot||!changes.length||typeof reason!=='string'||!reason.trim()||reason.length>1000)throw Error('Review changed tools and enter a reason before saving.')
  return {userId:snapshot.userId,changes,reason:reason.trim(),expectedVersion:snapshot.version,expectedFingerprint:snapshot.fingerprint}
}

// A global Team edit must not erase per-person exclusions created by this editor.
export function toolRuleForSave(mode,users,current){
  return {mode,users:mode==='selected'?users:[],...(mode==='team'&&current?.mode==='team'&&current.excludedUsers?.length?{excludedUsers:[...current.excludedUsers]}:{})}
}
